import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../../../styles/styles';

const { colors, spacing, common } = THEME;

export const styleSheet = StyleSheet.create({
	editContainer: {
		position: 'relative',
		height: '100%',
		overflowY: 'auto',
		width: '100%',
		padding: `0 ${spacing.md}px`,
		boxSizing: 'border-box',
	},
	editInput: {
		borderRadius: common.borderRadius,
		width: '100%',
		...CssSelectors.allDescendants(
			{
				borderRadius: common.borderRadius,
			},
			'input'
		),
	},
	editHeader: {
		// This is a hack to make the Avatar to not be cut off by the border radius
		marginLeft: 1,
	},
	container: {
		position: 'relative',
		height: '100%',
		overflowY: 'auto',
		width: '100%',
		backgroundColor: colors.background.light,
		padding: `0 ${spacing.md}px`,
		boxSizing: 'border-box',
	},
	profileSection: {
		boxSizing: 'border-box',
		height: 80,
		margin: `0 -16px`,
		padding: `24px 16px 0`,
		backgroundColor: `rgb(from ${colors.hover.light} r g b / 0.5)`,
	},
	archivedBanner: {
		alignItems: 'center',
		backgroundColor: colors.danger.light,
		display: 'flex',
		justifyContent: 'center',
		// Escape the container's horizontal padding so the banner spans edge-to-edge
		marginLeft: -16,
		marginRight: -16,
		padding: `4px 8px`,
		gap: 8,
		':has(*) svg': {
			display: 'block',
		},
	},
	archivedBannerText: {
		color: colors.danger.main,
		fontSize: 12,
		fontWeight: 600,
	},
	profileInfoSection: {
		marginTop: spacing.lg,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: spacing.sm,
	},
	profileInfoAvatarSection: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		gap: spacing.sm,
		width: '100%',
	},
	profileInfoAvatar: {
		height: 80,
		width: 80,
		fontSize: 32,
	},
	editHeaderAvatarContainer: {
		gap: spacing.sm,
	},
	viewFullScreenButton: {
		width: '100%',
	},
	nameSection: {
		marginTop: 0,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
	},
	nameSectionContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		alignItems: 'center',
	},

	editButton: {
		position: 'absolute',
		top: 0,
		right: 0,
	},

	contactName: {
		fontSize: 20,
		fontWeight: 600,
		margin: 0,
		color: colors.text.main,
	},
	jobTitleContainer: {
		fontSize: 14,
		...CssSelectors.allChildren(
			{
				textDecoration: 'none',
			},
			'a'
		),
	},
	// Interaction Section
	interactionSection: {
		marginTop: spacing.sm,
	},
	visibilitySection: {
		marginTop: spacing.xs,
	},
	actionsSection: {
		marginTop: spacing.md,
		display: 'flex',
		justifyContent: 'center',
		gap: spacing.md,
	},

	quickActionButton: {
		width: 40,
		height: 40,
		padding: 0,
		backgroundColor: colors.primary.main,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},

	quickActionIcon: {
		margin: '0 !important',
	},

	keepInTouchSection: {
		marginTop: spacing.md,
	},

	keepInTouchInfo: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: spacing.sm,
	},

	keepInTouchText: {
		fontSize: 14,
		flexGrow: 1,
	},

	keepInTouchChangeBtn: {
		display: 'flex',
		justifyContent: 'flex-end',
	},

	keepInTouchOption: {
		padding: spacing.sm,
		borderRadius: common.borderRadius,
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},

	keyFactsSection: {
		marginTop: spacing.md,
	},

	keyFactItem: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'center',
		justifyContent: 'space-between',
		':hover': {
			':nth-child(1n) .keyFactItemActions': {
				display: 'flex',
			},
		},
		':nth-child(1n) .deleting': {
			display: 'flex',
		},
	},
	keyFactItemValueContainer: {
		backgroundColor: colors.background.main,
		padding: spacing.xs,
		borderRadius: common.borderRadius,
		width: 'fit-content',
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.xs,
	},
	keyFactItemValue: {
		fontSize: 12,
		color: colors.text.main,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'pre-wrap',
		lineHeight: 1.5,
		paddingLeft: spacing.xs,
		paddingRight: spacing.xs,
	},
	keyfactHouseholdItemValue: {
		display: 'flex',
	},
	keyFactItemDate: {
		fontSize: 11,
		color: colors.text.light,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	keyFactItemActions: {
		display: 'none',
		flexDirection: 'row',
		gap: spacing.xs,
		alignItems: 'center',
		justifyContent: 'center',
	},
	keyFactItemActionButton: {
		padding: 0,
	},
	keyFactsContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
	},

	keyFactsListContainer: {
		width: '100%',
	},

	keyFactsList: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	keyFactsIcon: {
		minWidth: 24,
		minHeight: 24,
	},

	keyFactsItem: {
		width: 'fit-content',
		padding: `${spacing.xs}px ${spacing.sm}px`,
		borderRadius: common.borderRadius,
		backgroundColor: colors.tertiary.light,
		color: colors.tertiary.dark,
		fontSize: 14,
	},

	// Household-specific styles
	householdSpouseLink: {
		color: colors.primary.main,
		fontSize: 12,
		marginLeft: 4,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'underline',
		},
	},

	householdHomeIcon: {
		marginLeft: 4,
		display: 'inline-flex',
		alignItems: 'center',
	},

	householdPopoverContent: {
		backgroundColor: colors.success.light,
		border: `1px solid ${colors.success.main}`,
		borderRadius: common.borderRadius,
		fontSize: 12,
		maxWidth: 300,
		padding: spacing.sm,
	},

	tagsSection: {
		marginTop: spacing.md,
	},

	// Contact Details Section
	contactDetailsSection: {
		backgroundColor: colors.background.light,
	},
	contactDetailItem: {
		display: 'flex',
		alignItems: 'center',
		padding: '12px 16px',
		borderBottom: `1px solid ${colors.border.light}`,
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.border.light,
		},
	},
	contactDetailContent: {
		flex: 1,
		marginLeft: 12,
	},
	contactDetailValue: {
		fontSize: 16,
		color: colors.text.main,
		marginBottom: 2,
	},
	contactDetailSecondary: {
		fontSize: 14,
		color: colors.text.light,
		marginBottom: 4,
	},
	addContactDetail: {
		fontSize: 14,
		color: colors.primary.main,
		cursor: 'pointer',
	},
	contactDetailAction: {
		fontSize: 18,
		color: colors.text.light,
		marginLeft: 8,
	},
	emailIcon: {
		fontSize: 18,
		color: colors.success.dark,
	},
	phoneIcon: {
		fontSize: 18,
		color: colors.info.main,
	},
	phoneNumberFormContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm,
	},
	phoneNumberSelectBox: {
		borderRadius: common.borderRadius,
		border: common.border,
	},
	addressIcon: {
		fontSize: 18,
		color: colors.hover.dark,
	},
	addressFieldsContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'flex-start',
		justifyContent: 'space-between',
	},
	addressField: {
		width: 160,
	},

	// Legacy styles
	header: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		padding: 16,
		gap: 16,
		position: 'relative',
	},
	companyLink: {},

	// KeyFacts styles (ported from Contact/components/styles.ts)
	dataOriginContainer: {
		width: 'calc(100% - 16px - 8px - 24px - 8px)', // Equivalent to original calc
	},
	factText: {
		display: 'flex',
		flexWrap: 'wrap',
		overflowWrap: 'break-word',
		width: '100%',
		wordBreak: 'break-word',
		wordWrap: 'break-word',
		...CssSelectors.allChildren(
			{
				marginRight: 4,
			},
			':first-child'
		),
	},
	item: {
		':nth-child(1n) .entity-info-bullet-list-item-edit-button': {
			opacity: 0,
			pointerEvents: 'none',
		},
		':nth-child(1n) > .entity-info-bullet-list-item-bullet': {
			marginTop: 2,
		},
		alignItems: 'flex-start',
		color: colors.text.main,
		display: 'flex',
		fontSize: 14,
		listStyle: 'none',
		padding: '4px 0',
	},
	itemWithHover: {
		':hover': {
			':nth-child(1n) .entity-info-bullet-list-item-edit-button': {
				opacity: 1,
				pointerEvents: 'all',
			},
			background: colors.hover.light,
		},
	},
	itemToBeDeleted: {
		':nth-child(1n) .entity-info-bullet-list-item-edit-button': {
			opacity: 1,
			pointerEvents: 'all',
		},
		background: colors.hover.light,
	},
	itemEditing: {
		':nth-child(1n) > .entity-info-bullet-list-item-bullet': {
			marginTop: 0,
		},
		alignItems: 'center',
	},
	// CustomFields styles
	customFieldsSection: {
		marginTop: spacing.md,
	},
	customFieldsContainer: {
		display: 'flex',
		gap: spacing.xs,
	},
	customFieldsIcon: {
		minWidth: 24,
		minHeight: 24,
	},
	customFieldItem: {
		padding: `${spacing.xs}px`,
		'--custom-field-value-display-edit-button-opacity': '0',
		':hover': {
			backgroundColor: colors.border.light,
			'--custom-field-value-display-edit-button-opacity': '1',
		},
	},
	customFieldLabel: {
		fontSize: 12,
		fontWeight: 600,
		color: colors.text.light,
		marginBottom: spacing.xs,
	},
	customFieldData: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		minHeight: 20,
	},
	customFieldValue: {
		fontSize: 14,
		color: colors.text.main,
	},
	customFieldPlaceholder: {
		fontSize: 14,
		color: colors.text.light,
		fontStyle: 'italic',
	},
	customFieldEditButton: {
		borderRadius: common.borderRadius,
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		// @ts-ignore
		opacity: 'var(--custom-field-value-display-edit-button-opacity)',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},

	// Semantic styles for CustomFields editing behavior
	customFieldEditingForm: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: spacing.sm,
	},
	customFieldActionsRow: {
		display: 'flex',
		gap: spacing.sm,
	},
	customFieldSaveButton: {
		padding: `${spacing.xs}px ${spacing.sm}px`,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.main}`,
		backgroundColor: colors.primary.main,
		color: colors.primary.contrastText,
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.primary.dark,
		},
		':disabled': {
			opacity: 0.6,
			cursor: 'not-allowed',
		},
	},
	customFieldCancelButton: {
		padding: `${spacing.xs}px ${spacing.sm}px`,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.main}`,
		backgroundColor: 'transparent',
		color: colors.text.main,
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	customFieldValueDisplay: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
	},
	customFieldValueContent: {
		flex: 1,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	customFieldsContent: {
		flex: 1,
		width: '100%',
	},

	// ContactDetails styles
	contactDetailsInfoSection: {
		marginTop: spacing.md,
	},
	contactDetailsContainer: {
		marginTop: spacing.md,
	},
	contactDetailSection: {
		marginBottom: spacing.lg,
		paddingBottom: spacing.md,
	},
	contactDetailUnsubscribeCheckbox: {
		marginBottom: spacing.sm,
		fontSize: 14,
		color: colors.text.main,
	},
	contactDetailUnsubscribeInfo: {
		marginTop: `${spacing.xs}px !important`,
		marginBottom: 0,
	},
	contactDetailSendButtonStack: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
	},
	contactDetailSendEmailButton: {
		padding: `${spacing.xs}px ${spacing.sm}px`,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.main}`,
		backgroundColor: colors.primary.main,
		color: colors.primary.contrastText,
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.primary.dark,
		},
	},
	contactDetailEmails: {
		marginTop: spacing.sm,
		maxWidth: 330,
	},
	emailCardContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.lg,
	},
	emailCard: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'flex-start',
		minHeight: 20,
	},
	websiteCard: {
		alignItems: 'center',
	},
	emailCardIcon: {
		paddingTop: spacing.xs,
	},
	emailCardContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		gap: spacing.sm,
		width: '100%',
	},
	emailCardContentRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		minHeight: 32,
		justifyContent: 'space-between',
		width: '100%',
		':hover': {
			':nth-child(1n) .actions': {
				display: 'flex',
			},
		},
		':nth-child(1n) .visible': {
			display: 'flex',
		},
	},
	websiteCardContentRow: {
		alignItems: 'center',
	},
	emailCardValue: {
		margin: 0,
		maxWidth: 260,
		width: 260,
		display: 'inline-block',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		cursor: 'pointer',
		color: colors.text.main,
		textDecoration: 'none',
		':hover': {
			textDecoration: 'none',
		},
	},
	emailCardLabel: {
		fontSize: 12,
		fontWeight: 600,
		color: colors.text.light,
		margin: 0,
		padding: 0,
	},
	emailCardPrimaryLabel: {
		fontSize: 12,
		fontWeight: 600,
		color: colors.success.dark,
		marginBottom: spacing.xs,
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
	},
	emailCardDropdownContent: {
		minWidth: 196,
	},
	emailCardActions: {
		display: 'none',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'flex-start',
	},
	emailCardActionButton: {
		paddingTop: 0,
	},
	emailCardDeleteButton: {
		display: 'flex',
		userSelect: 'none',
		alignItems: 'center',
		gap: '8px',
		borderRadius: '2px',
		padding: 0,
		fontSize: '0.875rem',
		outline: 'none',
		color: 'rgb(118, 118, 118)',
	},
	emailCardSendButton: {
		...CssSelectors.allChildren(
			{
				display: 'flex',
				alignItems: 'center',
			},
			'span'
		),
	},
	emailCardAddButton: {
		paddingLeft: spacing.lg,
	},
	entityInfoFieldLabel: {
		fontSize: 12,
		fontWeight: 600,
		color: colors.text.dark,
		marginBottom: spacing.sm,
		marginTop: spacing.sm,
		boxSizing: 'border-box',
		display: 'inline-flex',
		width: '100%',
	},

	contactDetailSendAIEmailButton: {
		padding: `${spacing.xs}px ${spacing.sm}px`,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.main}`,
		backgroundColor: 'transparent',
		color: colors.text.main,
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	contactDetailSendCardButton: {
		padding: `${spacing.xs}px ${spacing.sm}px`,
		borderRadius: common.borderRadius,
		border: `1px solid ${colors.border.main}`,
		backgroundColor: colors.primary.main,
		color: colors.primary.contrastText,
		fontSize: 12,
		fontWeight: 600,
		cursor: 'pointer',
		':hover': {
			backgroundColor: colors.primary.dark,
		},
	},
	addressCard: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
	},
	addressCardContent: {
		width: '100%',
	},
	contactDetailAddressEditButton: {
		position: 'absolute',
		top: spacing.xs,
		right: spacing.xs,
		padding: spacing.xs,
		borderRadius: common.borderRadius,
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		':hover': {
			backgroundColor: colors.hover.light,
		},
	},
	contactDetailAddressDisplay: {
		display: 'flex',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'flex-start',
		flexGrow: 1,
		':hover': {
			':nth-child(1n) .actions': {
				display: 'flex',
			},
		},
		':nth-child(1n) .visible': {
			display: 'flex',
		},
	},
	addressContent: {
		flexGrow: 1,
		paddingBottom: spacing.sm,
	},
	addressActions: {
		display: 'none',
		flexDirection: 'row',
		gap: spacing.sm,
		alignItems: 'flex-start',
	},
	contactDetailAddressAddButton: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.xs,
		fontSize: 14,
		color: colors.text.light,
	},
	contactDetailBio: {
		fontSize: 14,
		color: colors.text.main,
		lineHeight: 1.4,
		wordBreak: 'break-word',
	},

	// Sticky form layout styles
	stickyContainer: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	editContainerContent: {
		paddingRight: spacing.md,
	},
	editTitle: {
		marginTop: spacing.md,
	},
	stickyScrollableContent: {
		flex: 1,
		overflowY: 'auto',
	},
	stickyFooter: {
		alignItems: 'center',
		bottom: 0,
		display: 'flex',
		left: 0,
		padding: spacing.md,
		position: 'sticky',
		right: 0,
		zIndex: 100,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	deleteContactSection: {
		paddingBottom: spacing.xxl,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: spacing.sm,
	},
});
